<template>
  <div>
    <vue-tailwind-datepicker
      :formatter="formatter"
      as-single
      v-model="dateValue"
      placeholder=" "
      v-slot="{ value, placeholder }"
      :disable-date="dDate"
      :disabled="disabled"
      :class="{ 'pointer-events-none opacity-60': disabled }"
    >
      <div class="flex">
        <button
          class="flex justify-between w-full rounded-sm border py-2 px-3 border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
          :value="value || placeholder"
        >
          <span class="flex whitespace-nowrap items-center">
            <CalendarIcon class="h-5 w-5 text-gray-500" v-if="props.blank" />
            <span>
              {{
                dateValue?.length === 0
                  ? ""
                  : format(new Date(dateValue), "LLL d, yyyy")
              }}
            </span>
          </span>
          <span class="ml-2" v-if="!props.blank">
            <ChevronDownIcon
              v-if="dateValue.length === 0"
              class="h-5 w-5 text-gray-900"
              aria-hidden="true"
            />
            <XMarkIcon
              v-else
              @click.prevent="clear"
              class="h-5 w-5 text-sky-900"
              aria-hidden="true"
            />
          </span>
        </button>
      </div>
    </vue-tailwind-datepicker>
  </div>
</template>

<script setup>
import { format } from "date-fns";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/vue/20/solid";
import { CalendarIcon } from "@heroicons/vue/24/outline";
import VueTailwindDatepicker from "vue-tailwind-datepicker";

import { defineEmits, defineProps, ref, unref, watch } from "vue";
import { useUTC } from "@/Tailwind/Mixins/useUTC";

const { fromUTC } = useUTC();

const props = defineProps({
  scheduleDate: [String, Date],
  disabled: Boolean,
});

const dDate = (date) => {
  const past = new Date();
  past.setDate(past.getDate() - 1);

  return date < past;
};

const emit = defineEmits(["change"]);

const dateValue = ref(
  props.scheduleDate ? fromUTC(props.scheduleDate).toISOString() : ""
);
const formatter = ref({
  date: "DD MMM YYYY",
  month: "MMM",
});

watch(dateValue, () => {
  emit("change", unref(dateValue));
});

const clear = () => (dateValue.value = "");
</script>
